import { Routes, Route, Navigate } from 'react-router-dom'
import DashboardPage from './pages/DashboardPage'
import UserManagementPage from './pages/UserManagementPage'
import CustomFieldPage from './pages/CustomFieldPage'
import SimProviderPage from './pages/SimProviderPage'
import BulkAllocateSimsPage from './pages/BulkAllocateSimsPage'
import ViewConfigurationsPage from './pages/ViewConfigurations'
import CreateConfigurationPage from './pages/CreateConfiguration'
import ChannelPartnerManagementPage from './pages/ChannelPartnerManagementPage'
import BulkUploadDevicesPage from './pages/BulkUploadDevices'
import AuditLogsPage from './pages/AuditLogsPage'
import NotFoundErrorPage from './pages/errors/NotFoundErrorPage'
import ProtectedRoute from './components/ProtectedRoute'
import { PermissionScope } from './services/AuthService'
import { RESOURCES } from './constants/resources'
import InternalUserManagementPage from './pages/InternalUserManagementPage'
import { PAGES } from './constants/pages'
import DevicesPage from './pages/devices/DevicesPage'
import PlatformDevicesPage from './pages/reporting/PlatformDevicesPage'

export default function AppRoutes() {

  return (
    <Routes>
      <Route path="/" element={<DashboardPage />} />

      <Route 
        path={PAGES.SOLOPROTECT_USERS.route} 
        element={
          <ProtectedRoute resource={[RESOURCES.INTERNAL_USERS]} scope={PermissionScope.READ}>
            <InternalUserManagementPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path={PAGES.USERS.route} 
        element={
          <ProtectedRoute resource={[RESOURCES.PARTNER_USERS]} scope={PermissionScope.READ}>
            <UserManagementPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path={PAGES.DEVICES.route} 
        element={
          <ProtectedRoute resource={RESOURCES.DEVICES} scope={PermissionScope.READ}>
            <DevicesPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path={PAGES.CUSTOM_FIELDS.route} 
        element={
          <ProtectedRoute resource={RESOURCES.CUSTOM_FIELDS} scope={PermissionScope.READ}>
            <CustomFieldPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path={PAGES.SIM_PROVIDERS.route} 
        element={
          <ProtectedRoute resource={RESOURCES.SIM_PROVIDERS} scope={PermissionScope.READ}>
            <SimProviderPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path={PAGES.BULK_UPLOAD_SIMS.route} 
        element={
          <ProtectedRoute 
            resource={RESOURCES.BULK_UPLOAD_SIMS} 
            scope={[PermissionScope.CREATE, PermissionScope.READ, PermissionScope.UPDATE, PermissionScope.DELETE]}
          >
            <BulkAllocateSimsPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path={PAGES.VIEW_CONFIGURATION.route} 
        element={
          <ProtectedRoute resource={[RESOURCES.DEFAULT_CONFIG, RESOURCES.PARTNER_CONFIG]} scope={PermissionScope.READ}>
            <ViewConfigurationsPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path={PAGES.CREATE_CONFIGURATION.route} 
        element={
          <ProtectedRoute resource={[RESOURCES.DEFAULT_CONFIG, RESOURCES.PARTNER_CONFIG]} scope={PermissionScope.CREATE}>
            <CreateConfigurationPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path={PAGES.PARTNERS.route} 
        element={
          <ProtectedRoute resource={RESOURCES.PARTNERS} scope={PermissionScope.READ}>
            <ChannelPartnerManagementPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path={PAGES.BULK_UPLOAD_DEVICES.route} 
        element={
          <ProtectedRoute 
            resource={RESOURCES.BULK_UPLOAD_DEVICES} 
            scope={[PermissionScope.CREATE, PermissionScope.READ, PermissionScope.UPDATE, PermissionScope.DELETE]}
          >
            <BulkUploadDevicesPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path={PAGES.PLATFORM_AUDIT_LOGS.route} 
        element={
          <ProtectedRoute resource={RESOURCES.PLATFORM_AUDIT_LOGS} scope={PermissionScope.READ}>
            <AuditLogsPage />
          </ProtectedRoute>
        } 
      />

      <Route 
        path={PAGES.DEVICE_EXPORT.route} 
        element={
          <ProtectedRoute resource={RESOURCES.PLATFORM_DEVICES} scope={PermissionScope.READ}>
            <PlatformDevicesPage />
          </ProtectedRoute>
        } 
      />

      <Route path={PAGES.ERRORS.NOT_FOUND.route} element={<NotFoundErrorPage />} />
      <Route path="*" element={<Navigate to={PAGES.ERRORS.NOT_FOUND.route} replace />} />
    </Routes>
  )
}